export default __webpack_public_path__ + "static/img-art-pandas-profiling-10-5d8966af439dac89ba9b729f961898fe.webp";